import { useQuery } from "@tanstack/react-query";
import { getUserProfileApi } from "@/services/api/profile";

/**
 * 获取用户信息的自定义Hook
 * @param user_id 用户ID
 * @returns React Query的查询结果
 */
export function useUserProfile(user_id?: string) {
  return useQuery({
    queryKey: ["userProfile", user_id],
    queryFn: async () => {
      if (!user_id) return null;
      const response = await getUserProfileApi({ user_id });

      // 在queryFn中处理响应数据
      if (response?.code === 200 && response.data) {
        // 存储beta状态信息到localStorage，供全局使用
        localStorage.setItem(
          "audit_status",
          response.data.beta_data?.audit_status?.toString() || ""
        );
      }

      return response;
    },
    enabled: !!user_id, // 只有当user_id存在时才执行
    staleTime: 1000 * 60 * 5, // 5分钟过期，允许重新请求
  });
}

/**
 * 获取用户beta状态的工具函数
 * @returns 用户的beta状态信息
 */
export function getUserAuditStatus() {
  return {
    audit_status: parseInt(localStorage.getItem("audit_status") || ""),
  };
}

/**
 * 检查用户内测申请是否已审核通过
 * @returns 是否已审核通过
 */
export function isUserAuditPassed() {
  return localStorage.getItem("audit_status") === "1";
}
